import React, { Component } from 'react'
import {inject, observer} from "mobx-react";
import ReactExport from "react-data-export";
import IconButton from '../../../comum/components/IconButton'
import moment from 'moment'

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

@inject("store")
@observer
export default class ExportarExcelMovimentacao extends Component {

    constructor(props){
        super(props)
        this.controller = this.props.controller
        this.timeRegExp = new RegExp("([0-9]{4}\-[0-9]{2}\-[0-9]{2}T[0-9]{2}\:[0-9]{2}:[0-9]{2})")
    }

    render() {
        let lista = this.controller.listaItens.length ? this.controller.getListaCopia() : []
        let categorias = this.controller.getCategorias()
        let desabilita
        if(!this.controller.listaItens.length){
            desabilita = true
        }else{
            desabilita = false
        }

        if(lista.length > 0){
            lista.map(data => {
                const keys = Object.keys(data)
                keys.map(key =>{
                    if(this.timeRegExp.test(data[key]) && moment(data[key]).format("DD/MM/YYYY HH:mm") !== 'Invalid date'){
                        data[key] = moment(data[key]).format("DD/MM/YYYY HH:mm")
                    }
                    if(key === "Categoria"){
                        const cat = categorias.find(cat => cat.value === data[key])
                        data[key] = cat && cat.label
                    }
                })
            })
        }

        return (
            <ExcelFile filename={"Movimentação"} element={
                <IconButton
                icon="file-excel"
                text="Baixar XLS"
                size="md"
                disabled={desabilita}
            />}>
                <ExcelSheet data={lista} name={"Movimentação"}>
                    {this.controller.colunas.map((col, index)=>
                        <ExcelColumn
                            key = {index}
                            value = {col.dataField}
                            label = {col.text}
                        />
                    )}
                </ExcelSheet>
            </ExcelFile>
            
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/consultas/movimentação/components/ExportarExcelMovimentacao.js